import { DatePicker } from "@material-ui/pickers";
import {
  AutocompleteArrayInput,
  FormDataConsumer,
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectInput,
  useAuthenticated,
} from "react-admin";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { RouteComponentProps } from "react-router-dom";
import { ReportForm } from "../common/ReportForm";
import resourceNames from "../../../common/data/resourceNames";
interface Props extends RouteComponentProps {}

export const VehicleInactivityReport = (props: Props) => {
  useAuthenticated();

  return (
    <ReportForm
      reportName="vehicle-inactivity-report"
      {...props}
      title="resources.reports.vehicleInactivity.name"
      submitMethod={(x) => x.reportVehicleinactivityreportPost}
    >
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateFrom"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <GenericDateOrTimePicker
        PickerComponent={DatePicker}
        source="dateTo"
        options={{
          autoOk: true,
          format: "MMMM do yyyy",
        }}
        validate={required()}
      />
      <ReferenceInput
        validate={required()}
        reference={resourceNames.ADMIN_COMPANIES}
        source="companyId"
      >
        <SelectInput />
      </ReferenceInput>
      <FormDataConsumer>
        {({ formData, ...rest }) => {
          return (
            formData["companyId"] && (
              <ReferenceArrayInput
                reference={resourceNames.ADMIN_VEHICLES}
                source="vehicles"
                filter={{ companyId: formData["companyId"] }}
                {...rest}
              >
                <AutocompleteArrayInput />
              </ReferenceArrayInput>
            )
          );
        }}
      </FormDataConsumer>
    </ReportForm>
  );
};
